import React, { Component } from "react";
import validator from "validator";
import { PageMode } from "../../../../../utils/constant";

export default class InitialSituation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
    };
  }
  submit = (e) => {
    e.preventDefault();
    if (this.props.mode === PageMode.add) {

      if (
        validator.isEmpty(this.props.data.date_investigation.value) ||
        validator.isEmpty(this.props.data.health_service_description.value) ||
        validator.isEmpty(this.props.data.date_net_distribution.value) ||
        validator.isEmpty(this.props.data.net_number.value) ||
        validator.isEmpty(this.props.data.date_last_irs.value) ||
        validator.isEmpty(this.props.data.number_houses_irs.value) ||
        validator.isEmpty(this.props.data.date_last_mbs.value) ||
        validator.isEmpty(this.props.data.number_of_people_mbs.value)
      ) {
        this.setState({
          error: true,
        });
        toast.error("Input Wajib Diisi tidak boleh kosong", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        this.props.nextStep();
      }
    } else {
      this.props.nextStep();
    }
  };

  render() {
    const {
      data,
      onInputChange,
      handleChecked
    } = this.props;
    
    return (
      <div className="form-wrapper">
        <div className="form-title">
          <p className="font-weight-bold">Situasi Awal</p>
        </div>
        <div className="form-group">
          <label htmlFor="date_investigation">
            Tanggal Penyelidikan Fokus <sup className="text-danger">*</sup>
          </label>
          <input
            type="date"
            name="date_investigation"
            id="date_investigation"
            className="form-control"
            value={data.date_investigation.value}
            onChange={onInputChange}
          />
          {data.date_investigation && (
            <span className="text-danger">{data.date_investigation.message}</span>
          )}
        </div>
        <div className="form-group">
          <label htmlFor="health_service_description">
            Deskripsi akses pelayanan kesehatan
            <sup className="text-danger">*</sup>
          </label>
          <textarea
            name="health_service_description"
            id="health_service_description"
            className="form-control"
            value={data.health_service_description.value}
            onChange={onInputChange}
          ></textarea>
          {data.health_service_description && (
            <span className="text-danger">{data.health_service_description.message}</span>
          )}
        </div>
        <div className="form-group">
          <label htmlFor="date_net_distribution">
            Tanggal pembagian kelambu terakhir
            <sup className="text-danger">*</sup>
          </label>
          <input
            type="date"
            name="date_net_distribution"
            id="date_net_distribution"
            className="form-control"
            value={data.date_net_distribution.value}
            onChange={onInputChange}
          />
          {data.date_net_distribution && (
            <span className="text-danger">{data.date_net_distribution.message}</span>
          )}
        </div>
        <div className="form-group">
          <label htmlFor="net_number">
            Jumlah kelambu dibagikan
            <sup className="text-danger">*</sup>
          </label>
          <input
            type="numberOnly"
            className="form-control"
            name="net_number"
            id="net_number"
            onChange={onInputChange}
            value={data.net_number.value}
          />
          {data.net_number && (
            <span className="text-danger">{data.net_number.message}</span>
          )}
        </div>
        <div className="form-group">
          <label htmlFor="date_last_irs">
            Tanggal IRS Terakhir
            <sup className="text-danger">*</sup>
          </label>
          <input
            type="date"
            name="date_last_irs"
            id="date_last_irs"
            className="form-control"
            value={data.date_last_irs.value}
            onChange={onInputChange}
          />
          {data.date_last_irs && (
            <span className="text-danger">{data.date_last_irs.message}</span>
          )}
        </div>
        <div className="form-group">
          <label htmlFor="number_houses_irs">
            Jumlah yang di IRS
            <sup className="text-danger">*</sup>
          </label>
          <input
            type="numberOnly"
            className="form-control"
            name="number_houses_irs"
            id="number_houses_irs"
            onChange={onInputChange}
            value={data.number_houses_irs.value}
          />
          {data.number_houses_irs && (
            <span className="text-danger">{data.number_houses_irs.message}</span>
          )}
        </div>
        <div className="form-group">
          <label htmlFor="date_last_mbs">
            Tanggal MBS Terakhir
            <sup className="text-danger">*</sup>
          </label>
          <input
            type="date"
            name="date_last_mbs"
            id="date_last_mbs"
            className="form-control"
            value={data.date_last_mbs.value}
            onChange={onInputChange}
          />
          {data.date_last_mbs && (
            <span className="text-danger">{data.date_last_mbs.message}</span>
          )}
        </div>
        <div className="form-group">
          <label htmlFor="number_of_people_mbs">
            Jumlah yang di MBS
            <sup className="text-danger">*</sup>
          </label>
          <input
            type="numberOnly"
            className="form-control"
            name="number_of_people_mbs"
            id="number_of_people_mbs"
            onChange={onInputChange}
            value={data.number_of_people_mbs.value}
          />
          {data.number_of_people_mbs && (
            <span className="text-danger">{data.number_of_people_mbs.message}</span>
          )}
        </div>
        <div className="form-group">
          <label htmlFor="types_of_mosquito_breeding">
            Jenis Perindukan nyamuk (Dapat memilih lebih dari satu)
          </label>
          <br />
          <input
            type="checkbox"
            name={"types_of_mosquito_breeding"}
            value="Kolam"
            defaultChecked={data.types_of_mosquito_breeding.value === "Kolam" ? true : false}
            onChange={handleChecked}
          />{" "}
          <label htmlFor="kolam">Kolam</label>
          <br />
          <input
            type="checkbox"
            name={"types_of_mosquito_breeding"}
            value="Sungai"
            defaultChecked={data.types_of_mosquito_breeding.value === "Sungai" ? true : false}
            onChange={handleChecked}
          />{" "}
          <label htmlFor="Sungai">Sungai</label>
          <br />
          <input
            type="checkbox"
            name={"types_of_mosquito_breeding"}
            value="Sawah"
            defaultChecked={data.types_of_mosquito_breeding.value === "Sawah" ? true : false}
            onChange={handleChecked}
          />{" "}
          <label htmlFor="Sawah">Sawah</label>
          <br />
          <input
            type="checkbox"
            name={"types_of_mosquito_breeding"}
            value="Lagun"
            defaultChecked={data.types_of_mosquito_breeding.value === "Lagun" ? true : false}
            onChange={handleChecked}
          />{" "}
          <label htmlFor="Lagun">Lagun</label>
          <br />
          <input
            type="checkbox"
            name={"types_of_mosquito_breeding"}
            value="Parit"
            defaultChecked={data.types_of_mosquito_breeding.value === "Parit" ? true : false}
            onChange={handleChecked}
          />{" "}
          <label htmlFor="Parit">Parit</label>
          <br />
          <input
            type="checkbox"
            name={"types_of_mosquito_breeding"}
            value="Bekas Galian"
            defaultChecked={data.types_of_mosquito_breeding.value === "Bekas Galian" ? true : false}
            onChange={handleChecked}
          />{" "}
          <label htmlFor="Bekas Galian">Bekas Galian</label>
          <br />
          <input
            type="checkbox"
            name={"types_of_mosquito_breeding"}
            value="Rawa"
            defaultChecked={data.types_of_mosquito_breeding.value === "Rawa" ? true : false}
            onChange={handleChecked}
          />{" "}
          <label htmlFor="Rawa">Rawa</label>
          <br />
          <input
            type="checkbox"
            name={"types_of_mosquito_breeding"}
            value="Tambak"
            defaultChecked={data.types_of_mosquito_breeding.value === "Tambak" ? true : false}
            onChange={handleChecked}
          />{" "}
          <label htmlFor="Tambak">Tambak</label>
          <br />
          <input
            type="checkbox"
            name={"types_of_mosquito_breeding"}
            value="Bekas Injakan Hewan"
            defaultChecked={data.types_of_mosquito_breeding.value === "Bekas Injakan Hewan" ? true : false}
            onChange={handleChecked}
          />{" "}
          <label htmlFor="Bekas injakan hewan">Bekas injakan hewan</label>
          <br />
          <input
            type="checkbox"
            name={"types_of_mosquito_breeding"}
            value="Lainnya"
            onChange={handleChecked}
          />{" "}
          <label htmlFor="Lainnya">Lainnya</label>
          <br />
          <span className="text-muted">Lainnya</span>
          <input
            type="text"
            className="form-control"
            name="types_of_mosquito_breeding"
            onChange={handleChecked}
            disabled={
              data.disableOther
            } />
          
          {data.types_of_mosquito_breeding && (
            <span className="text-danger">{data.types_of_mosquito_breeding.message}</span>
          )}
        </div>
        <div className="form-action d-flex justify-content-end">
          <button
            className="btn btn-teal-outline font-weight-bold mr-2"
            onClick={this.onBack}
          >
            Kembali
          </button>
          <button
            className="btn btn-teal font-weight-bold"
            onClick={this.submit}
          >
            Selanjutnya
          </button>
        </div>
      </div>
    );
  }
}
